import { render, staticRenderFns } from "./komaBoard.vue?vue&type=template&id=a652bde2&scoped=true&"
import script from "./komaBoard.vue?vue&type=script&lang=js&"
export * from "./komaBoard.vue?vue&type=script&lang=js&"
import style0 from "./komaBoard.vue?vue&type=style&index=0&id=a652bde2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a652bde2",
  null
  
)

export default component.exports